import React from "react";
import ReactDOM from "react-dom/client";
import ScrollToTop from "./ScrollToTop";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./utils/i18n";  // 👈 Initialize i18next before rendering

import { CommonContext } from "./context/commonContext";
import { LanguageProvider } from "./context/languageContext";
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'leaflet/dist/leaflet.css';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter basename="/">
      <LanguageProvider>
        <CommonContext>
          <ScrollToTop>
            <GoogleOAuthProvider clientId="969788662683-rfptvlffuia8ldgldk0mmlb5phq3t9h6.apps.googleusercontent.com">
              <App/>
            </GoogleOAuthProvider>
          </ScrollToTop>
        </CommonContext>
      </LanguageProvider>
    </BrowserRouter>
);
